import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import clsx from 'clsx'
import { Container, Grid, Paper, Tab, Tabs } from '@mui/material'
import PersonIcon from '@mui/icons-material/Person'

import TabPanel from '~shared/components/TabPanel'
import { useGlobalStyles } from '~shared/styles/globalStyles'
import { useAccountStyles } from '~app/screens/Account/Account.styles'

import Profile from './components/Profile'
import ScreenContainerMain from '~shared/components/ScreenContainerMain'

enum AccountTabEnum {
  profile = 'profile',
}

const Account: React.FC = () => {
  const s = useAccountStyles()
  const gs = useGlobalStyles()
  const { t } = useTranslation()

  const [activeTab, setActiveTab] = useState<AccountTabEnum>(AccountTabEnum.profile)

  const handleTabChange = (event: React.SyntheticEvent, value: AccountTabEnum) => {
    setActiveTab(value)
  }

  return <ScreenContainerMain useMobileVerticalPadding>
    <Grid item xs={12}>
      <Container maxWidth='md' className={gs.noMargin} disableGutters>
        <Paper className={clsx(s.tabContainer, gs.squareCornersBottom)}>
          <Tabs
            value={activeTab}
            indicatorColor='primary'
            textColor='primary'
            aria-label='icon tabs example'
            onChange={handleTabChange}
          >
            <Tab
              value={AccountTabEnum.profile}
              label={t('common:profile')}
              icon={<PersonIcon className={s.tabIcon} />}
              wrapped
            />
            {/*
              there are no personalization options currently - but when there are, this is already prepared :)
              <Tab value='personalization' label={t('common:personalization')} icon={<BrushIcon className={s.tabIcon} />} wrapped />
            */}
          </Tabs>
        </Paper>

        <TabPanel name={AccountTabEnum.profile} activeTab={activeTab}>
          <Profile />
        </TabPanel>

      </Container>
    </Grid>
  </ScreenContainerMain>
}

export default Account
